import LText from "@components/LText";
import Button from "../common/Button";
import LIcon from "@components/LIcon";
import useValidatedExternalUrl from "../../utils/useValidatedExternalUrl";

const GetSongExternal = ({
  accessId,
  extLinks,
}: {
  accessId: string;
  extLinks: string[];
}) => {
  const open = useValidatedExternalUrl(extLinks, { accessId });
  return (
    <Button.Button
      onPress={open}
      sentryEventName="AccessDetail.GetSongExternal"
    >
      <LIcon colors={{ color: "black" }} name="extlink" size={16} />
      <LText variant="Caption/C1/Medium" color="black">
        Get Song
      </LText>
    </Button.Button>
  );
};

export default GetSongExternal;
